(() => {
  const menu = document.getElementById('menu-footer-list');
  const container = document.getElementsByClassName('menu-footer-list-container')[0];
  if (!menu) return;

  const menuItems = Array.from(menu.querySelectorAll('li'));
  menuItems.slice(12).forEach((item) => {
    item.classList.toggle('hidden');
  });
  const showMoreButton = document.createElement('button');
  showMoreButton.classList.add('show-more-links');
  showMoreButton.textContent = 'Show more';

  container.appendChild(showMoreButton);
  showMoreButton.addEventListener('click', () => {
    menuItems.slice(12).forEach((item) => {
      item.classList.toggle('hidden');
    });

    showMoreButton.textContent = showMoreButton.textContent === 'Show more' ? 'Show less' : 'Show more';
  });
})()
